<template>
  <div class="system-container">
    <el-container class="system-body">
      <el-header class="animate__animated animate__fadeInDown">
        <div class="header-left-container">
          <Logo
            style="height: 40%"
            title="首页"
          />
          <!-- <span @click="toHome">&nbsp;&nbsp;Spark</span> -->
          &nbsp;&nbsp;&nbsp;&nbsp;
          <!-- <RouteNavigation /> -->
          <el-button type="primary" icon="CaretLeft" size="small"
            v-if="roleName !== '供应商'"
            @click="toHome"
            round
          >返回</el-button>
        </div>
        <div class="header-right-container">
          <DownloadCenter
            :style="{
              width: '1.875rem',
              height: '1.875rem',
              padding: '0.125rem',
              'border-radius': '0.3125rem',
              '--userIconColor': 'var(--iconColor)',
            }"
          />
          <UserInfo
            :style="{
              width: '1.875rem',
              height: '1.875rem',
              padding: '0.125rem',
              'border-radius': '0.3125rem',
              '--userIconColor': 'var(--iconColor)',
            }"
            :ThemeToggleShow="false"
            :updatePwdShow="true"
          />
        </div>
      </el-header>
      <el-container class="body-container">
        <el-aside
          class="animate__animated animate__fadeInLeft sidebar-container"
          :style="{
            '--bodyWidth': menuIsCollapse?'4rem':'15rem',
          }"
        >
          <div class="fold-container">
            <div class="fold-div" @click="menuIsCollapseChange">
              <svg-icon
                :iconName="menuIsCollapse?'el-CaretRight':'el-CaretLeft'"
              ></svg-icon>
            </div>
          </div>
          <div class="menu-list-container">
            <el-scrollbar>
              <MenuList />
            </el-scrollbar>
          </div>
          <!-- <div class="function-container"> -->
            <!-- <ThemeToggle /> -->
          <!-- </div> -->
        </el-aside>
        <el-main>
          <router-view
            class="animate__animated animate__fadeInRight main_container"
          ></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive
} from 'vue'
import { isNull, dayjs, message } from '@/utils/js/initVariable'
import router from '@/router'
import store from '@/store'
import { Message } from '@element-plus/icons-vue'
import MenuList from '@/components/MenuList'
import Logo from '@/components/Logo'
import ThemeToggle from '@/components/ThemeToggle'
import Pagination from '@/components/Pagination'
import RouteNavigation from '@/components/RouteNavigation'
import UserInfo from '@/components/UserInfo'
import DownloadCenter from '@/views/DownLoadCenter'

// props
const props = defineProps({

})
// emit
const emit = defineEmits([

])

const menuIsCollapse = computed(()=>{
  return store.getters['permissions/getMenuIsCollapse'];
});
const menuIsCollapseChange = ()=>{
  store.dispatch('permissions/menuIsCollapseChange', !menuIsCollapse.value);
}

const visible = ref(false)
const planTarget = ref(undefined)
let total = ref(0)
const listQuery = reactive({
  page: 1,
  limit: 10,
  name: ''
})

const viewDetails = (item) => {
  // console.log('查看详情:', item)
  if (item.type === 'image') {
    router.push('/GlobalExposure')
  } else if (item.type === 'case') {
    router.push('/CaseStudyExplanation')
  }
  visible.value = false
}

const togglePopover = () => {
  visible.value = !visible.value
}

const pageChange = () => {
  // console.log('换页')
  // getEvent()
}

const roleName = ref(localStorage.getItem('roleName') || '');

// 组件挂载前
onBeforeMount(()=>{

})
// 组件挂载后
onMounted(()=>{
})
// 组件更新后
onUpdated(()=>{

})
// 组件销毁后
onUnmounted(()=>{

})

const toHome = ()=>{
  if(roleName.value === '供应商')return;
  router.push('/')
}

const handleClickOutside = (event) => {
  const container = document.querySelector('.header-right-container')
  if (container && !container.contains(event.target)) {
    visible.value = false
  }
}

onBeforeMount(() => {
})
onUnmounted(() => {
})
</script>

<style lang='less'>
.header-right-container {
  .el-badge__content.is-fixed.is-dot {
    right: 10px;
    top: 3px;
  }
}
.homeheader-notice-title {
  display: flex;
  justify-content: space-between;
}
.menu-tootip-popper{
  background: var(--backgroundColor_18) !important;
  .el-menu{
    background: var(--backgroundColor_18) !important;
    opacity: 1;
    .el-menu-item{
      &:hover{
        background-color: var(--backgroundColor_33);
      }
    }
  }
}
</style>

<style lang='less' scoped>
.system-container{
  height: 100vh;
  width: 100%;
  background-color: var(--backgroundColor_24);
  overflow: hidden;
  .system-body{
    height: 100%;
    --headerHeight: 40px;
    .el-header{
      height: var(--headerHeight);
      // line-height: var(--headerHeight);
      background-color: var(--backgroundColor);
      box-shadow: var(--boxShadow);
      display: flex;
      justify-content: space-between;
      .header-left-container{
        height: 100%;
        width: max-content;
        display: flex;
        justify-content: center;
        align-items: center;
        span{
          color: var(--backgroundColor);
          line-height: calc(var(--homeHeaderHight) - 4px * 2);
          text-align: center;
          text-shadow: 0 0 1px var(--domFontColor);
          font-size: 27px;
          // font-family: 'OPPOSans-H';
          font-weight: bold;
          cursor: pointer;
        }
        #logo-context{
          cursor: pointer;
        }
      }
      .header-right-container{
        height: 100%;
        width: max-content;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .header-right-notice {
          position: relative;
          height: 40px;
          width: 40px;
          margin-right: 5px;
          border-radius: 10px;
          background-color: var(--backgroundColor);
          display: flex;
          justify-content: center;
          align-items: center;
          el-icon {
            font-size: 25px;
            color: var(--iconColor);
          }
        }
      }
    }
    .body-container{
      height: calc(100% - var(--headerHeight));
      .el-aside{
        width: var(--bodyWidth);
        background-color: var(--backgroundColor_18);
        box-shadow: var(--boxShadowBottom);
        transition: all 0.5s;
        --foldHeight: 40px;
        .fold-container{
          height: var(--foldHeight);
          padding: 5px;
          .fold-div{
            height: 100%;
            width: 100%;
            background-color: var(--backgroundColor_29);
            border-radius: var(--borderRadiusSize);
            display: flex;
            align-items: center;
            justify-content: flex-end;
            line-height: calc(var(--foldHeight) - 5px * 2);
            cursor: pointer;
          }
        }
        .menu-list-container{
          height: calc(100% - var(--foldHeight));
          transition: all 0.5s;
          border: none;
        }
        :deep(.el-scrollbar){
          .el-scrollbar__view{
            padding: 5px;
            .el-menu{
              width: 100%;
              background-color: transparent;
              .el-menu-item, .el-sub-menu__title{
                margin-bottom: 5px;
                border-radius: 8px;
                height: 40px;
                &:hover{
                  background-color: var(--backgroundColor_33);
                }
                .el-menu-tooltip__trigger{
                  justify-content: center;
                  width: 100%;
                }
              }
              .el-sub-menu{
                .el-sub-menu__title.el-tooltip__trigger{
                  justify-content: center;
                  width: 100%;
                  padding: 0;
                }
              }
              .el-menu-item.is-active{
                background-color: var(--backgroundColor_33);
              }
            }
          }
        }
        // .function-container{
        //   height: 10%;
        //   display: flex;
        //   justify-content: center;
        //   align-items: center;
        // }
      }
      .el-main{
        padding: 10px;
        overflow: hidden;
        .main_container{
          box-shadow: var(--boxShadow);
        }
      }
    }
  }
}
</style>